import short from "short-uuid";

let vueInstance = null;

const NotifyToast = {
    install(Vue) {
        const notifyStack = {};

        Vue.prototype.$toast = {

            /**
                * @param {String} message - main text for a simple toast // use this as title in complex toast (title + main text)
                * @param {String} caption -  use this as main text in complex toast (title + main text)
                * @param {String} type - type of toast --> available types - info/warning/error/success, default info
                * @param {String} code - use same code for notifications to the display just one at the same time
                * @param {Number} timeout - in milliseconds, default 5000
                * @param {Boolean} hasClose - close button ( X ), default true
                * @param {String} buttonLabel - label button, use this for a custom action
                * @param {Function} closeEvent - close action, by default toast will be closed, but u can add a custom one
                * @param {Function} actionEvent - button action
            */

            showNotify({
                message, caption, type = "info", code = short.generate(), timeout = 5000, hasClose = true,
                buttonLabel, closeEvent = () => {}, actionEvent = null
            }) {
                const data = {
                    toastIcon: "error_outline",
                    hasBothBtns: false,
                    closeObj: { label: "", icon: "close", handler: () => closeEvent(), attrs: { "data-scope": "close" } },
                    buttonObj: { label: buttonLabel, handler: () => actionEvent(), attrs: { "data-scope": "action" } },
                    myClasses: ["custom-aq-toast"]
                };

                let color = "white";
                if (type === "warning") {
                    color = "warning";
                    data.toastIcon = "warning_amber";
                    data.myClasses.push("warning-aq-toast");
                } else if (type === "error" || type === "negative") {
                    data.toastIcon = "error_outline";
                    color = "negative";
                    data.myClasses.push("error-aq-toast");
                } else if (type === "success" || type === "positive") {
                    data.toastIcon = "check_circle_outline";
                    color = "positive";
                    data.myClasses.push("success-aq-toast");
                } else {
                    data.myClasses.push("info-aq-toast");
                }

                const arrayCopy = [];
                if (hasClose) {
                    if (buttonLabel) {
                        arrayCopy.push(data.buttonObj, data.closeObj);
                        data.myClasses.push("aq-toast-two-buttons");
                    } else {
                        arrayCopy.push(data.closeObj);
                    }
                } else if (actionEvent !== null) {
                    arrayCopy.push(data.buttonObj);
                    data.myClasses.push("aq-toast-custom-action");
                }
                if (caption) {
                    data.myClasses.push("aq-toast-title");
                }
                const notifElem = document.getElementsByClassName("q-notifications__list--bottom items-center");
                const closeFunction = vueInstance.$q.notify({
                    message,
                    position: "bottom",
                    timeout,
                    caption,
                    color,
                    code,
                    multiLine: false,
                    group: false,
                    icon: data.toastIcon,
                    actions: arrayCopy
                });

                Vue.nextTick(() => {
                    if (notifElem && notifElem[0] && notifElem[0].children.length) {
                        notifElem[0].children[notifElem[0].children.length - 1].children[0].classList.add(...data.myClasses);
                    }
                });

                if (notifyStack.hasOwnProperty(code)) {
                    notifyStack[code]();
                }
                notifyStack[code] = closeFunction;

                return closeFunction;
            },
            init(mainVueInstance) {
                vueInstance = mainVueInstance;
            }
        };
    }
};

export default NotifyToast;
